import React, { useState } from 'react';
import Menubinder from '../menu';
import EgresoMaqueta from '../egresoMaqueta';
function VerEgreso() {
  const [menuOpen, setMenuOpen] = useState(true);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0c1f1d' }}>
      <Menubinder
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}  // actualiza margen del contenido
      />

      <main
        className="contenido-panel"
        style={{
          marginLeft: menuOpen ? 240 : 70,     // se adapta al ancho del menú
          width: '100%',
          transition: 'margin-left .25s ease',
          padding: 20,
          background: 'radial-gradient(900px 600px at -10% -10%, #183c34 0%, transparent 45%), #0c1f1d'
        }}
      >
        <EgresoMaqueta />
      </main>
    </div>
  );
}

export default VerEgreso;
